<template>
  <button
    :class="buttonClass"
    :data-tooltip="saleDisabled ? disabledTooltip : null"
    @click.stop="onClick"
  >
    <button-price
      class="market-button-direction__price"
      :price="price"
      :key="price"
      :text="text"
      :win="win"
      :sell="sell"
      :active="isActive"
    />
  </button>
</template>

<script src="./market-button-direction.js"></script>
<style src="./market-button-direction.scss" lang="scss"></style>
